export const FILTERS_TO_RESET = [
  'PLANNER_TAGS',
  'VENUE_TYPE',
  'DISPLAY_TYPES',
  'MAXIMUM_DISTANCE',
  'RATE_HISTORY',
  'AMENITIES',
  'RATINGS',
  'TOTAL_MEETING_SPACE',
  'EXHIBIT_SPACE',
  'LARGEST_ROOM',
  'SECOND_LARGEST_ROOM',
  'CEILING_HEIGHT',
  'CAPACITY_SEATED',
  'CAPACITY_STANDING',
  'NUMBER_OF_SLEEPING_ROOMS',
  'NUMBER_OF_MEETING_ROOMS',
  'AIRPORT_DISTANCE',
  'CITY',
  'COUNTRY_CODE',
  'MULTI_FILTER',
  'VENUE_DETAILS',
  'CANCELLED_SPACE',
  'PRICE_CATEGORY',
  'AREA_TYPE',
  'EVENT_START_DATE',
  'EVENT_END_DATE',
  'NUMBER_OF_ATTENDEES'
];

export const MAX_GUEST_ROOMS_LIMIT = 99999;
export const MAX_ATTENDEES_LIMIT = 999999;
export const MAX_SUGGESTIONS = 20;
export const NUMERIC_VALUE_REGEX = /^[0-9]*$/;
export const NUMERIC_VALUE_WITH_DECIMAL_REGEX = /^[0-9]*(\.[0-9]*)?$/;
export const TOP_RESPONDER_FILTER_TAG_VARIANT = 2;
export const TOP_RESPONDER_TAG_VARIANT = 1;
export const TOP_RESPONDER_OFF_VARIANT = 0;
export const BUSINESS_HOURS = 8;
